import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Modal from "react-awesome-modal";

import Navbar from "../../../components/CustomNav/CustomNav.Component";
import "./searchFilters.css";
import { currentBaseUrl } from "../../../common/services";
import withServices from "../../../HOCs/withServices";
import PieChart from "../../../common/DataViz/pie.Component";
import Loader from "react-loader";
import { FabButton } from "../../Onboard/Common/Common.styles";

import Tour from "reactour";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { toast, ToastContainer } from "react-toastify";

import { tourSteps } from "./SearchFiltersTour";

import { connect } from "react-redux";

import {
  getAssessmentSearchFilters,
  getAssessments,
  getYearGroupsDepartments,
  getStudentsFiltered,
  updateMultipleVals,
} from "../../../redux/ducks/schoolSearchFilters";
interface IProps {
  services?: any;
  history?: object;
  dispatch?: any;
  schoolSFReducer?: any;
}

class SearchFilters extends React.Component<IProps> {
  public state = {
    toLogin: false,
    datakey: ["User", "AlertLevel", "viewmore"],
    tHead: ["Name", "Risk Group", "Action"],
  };
  constructor(props) {
    super(props);
    this.resultsTableDisplay = this.resultsTableDisplay.bind(this);
    this.renderChart = this.renderChart.bind(this);
    this.assessmentPicker = this.assessmentPicker.bind(this);
    this.onLogout = this.onLogout.bind(this);
    this.searchFilterButtons = this.searchFilterButtons.bind(this);
    this.onSelectAssessment = this.onSelectAssessment.bind(this);
    this.onQuestionGroupClicked = this.onQuestionGroupClicked.bind(this);
    this.onPieSliceClicked = this.onPieSliceClicked.bind(this);
    this.viewMoreData = this.viewMoreData.bind(this);
    this.customTD = this.customTD.bind(this);
    this.fetchQuestionGroupData = this.fetchQuestionGroupData.bind(this);
    this.loadAssessmentWithFilters = this.loadAssessmentWithFilters.bind(this);
  }

  public async componentDidMount() {
    const {
      services: {
        institutionsAPI,
        adminAPI,
        isUserLoggedIn,
        currentUserID,
        fixturesAPI,
      },
      dispatch,
    } = this.props;

    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
      return;
    }

    dispatch(getAssessments(currentUserID));
  }
  public onLogout() {
    this.setState({ toLogin: true });
  }

  public closeFiltersModal = () => {
    this.props.dispatch(updateMultipleVals({ noFilters: false }));
  };

  public toggleGuides = () => {
    if (!this.props.schoolSFReducer.selectedAssessment) {
      toast.info("First pick an assessment above");
      return;
    }
    const { guidesRead } = this.props.schoolSFReducer;
    this.props.dispatch(updateMultipleVals({ guidesRead: !guidesRead }));
  };

  public closeTour = () => {
    localStorage.setItem(
      `${this.props.services.currentUsername}FiltersTour`,
      "true"
    );
    this.props.dispatch(updateMultipleVals({ guidesRead: true }));
  };

  public disableBody = (target) => {
    disableBodyScroll(target);
  };
  public enableBody = (target) => {
    enableBodyScroll(target);
  };
  public customTD(props) {
    return (
      <td>
        {/*tslint:disable-next-line jsx-no-lambda*/}
        <button
          className="blue-button view-more-data"
          onClick={this.viewMoreData.bind(this, props)}
        >
          View More
        </button>
      </td>
    );
  }
  public viewMoreData(props) {
    const history: any = this.props.history;
    history.push(`${currentBaseUrl()}viewstudentdata/${props.rowData.id}`);
  }

  public onSelectFilter = (filter, e) => {
    const { dispatch } = this.props;
    if (filter === "department") {
      dispatch(
        updateMultipleVals({
          currentDepartment: e.target.value,
          selectedGroup: 0,
        })
      );
      this.loadAssessmentWithFilters(`department=${e.target.value}`);
    }
    if (filter === "yrgrp") {
      dispatch(
        updateMultipleVals({
          currentYearGroup: e.target.value,
          selectedGroup: 0,
        })
      );
      this.loadAssessmentWithFilters(`year_group=${e.target.value}`);
    }
  };

  public async loadAssessmentWithFilters(filter) {
    const {
      services: { currentUserID, fixturesAPI, institutionsAPI },
      dispatch,
      schoolSFReducer,
    } = this.props;
    const { selectedAssessment } = schoolSFReducer;

    dispatch(updateMultipleVals({ loaded: false }));
    dispatch(
      getAssessmentSearchFilters(currentUserID, selectedAssessment, filter)
    );
  }

  public resultsTableDisplay() {
    // create table with student results
    const { filteredStudents, selectedGroup, questionGroups } = this.props.schoolSFReducer;
          const currentSF = questionGroups.find((e) => e.id === selectedGroup);

    if (filteredStudents.length) {
      return (
        <div className="filter-table-container animated fadeInUp">
          <h2 style={{marginTop: "-2.25em"}} className="school-profile-title">{currentSF.Title}</h2>
          <SortableTbl
            tblData={filteredStudents}
            tHead={this.state.tHead}
            dKey={this.state.datakey}
            customTd={[
              { custd: this.customTD, keyItem: "viewmore", sortable: false },
            ]}
            defaultCSS={false}
          />
        </div>
      );
    } else {
      return <div />;
    }
  }

  public renderChart() {
    // nivo radar mapping results
    const { questionGroups, selectedGroup } = this.props.schoolSFReducer;
    const pieData = [] as any;

    questionGroups.sort(function sortData(a, b) {
      return b.NumStudents - a.NumStudents;
    });

    questionGroups.forEach((group, i) => {
      pieData.push({
        id: String(group.id),
        label: group.Title.toUpperCase(),
        value: group.NumStudents,
        color: this.assignColor(selectedGroup, group.id)[0]
      });
    });

    return (
      <div className="radar-container">
        <PieChart realData={pieData} onSliceClick={this.onPieSliceClicked} />
      </div>
    );
  }

  public assignClass(selected, qGrp) {
    if (selected === qGrp) {
      return "sf-button sf-button-active";
    } else {
      return "sf-button";
    }
  }
  public assignColor(selected, qGrp) {
    if (selected === qGrp) {
      return ["#acff24", "#00ebff"];
    } else {
      return ["#acff2480", "#3ee9f7"];
    }
  }

  public assessmentPicker() {
    const {
      assessments,
      loaded,
      yearGroups,
      departments,
      selectedAssessment,
      currentYearGroup,
      currentDepartment,
    } = this.props.schoolSFReducer;
    // query header
    if (assessments.length) {
      return (
        <div className="sf-query-wrapper">
          <div className="sf-query">
            <div className="show-picker">
              <span>Please pick an assessment: </span>
              <span>
                <select
                  className="custom-select sf-select"
                  onChange={this.onSelectAssessment}
                  defaultValue={selectedAssessment}
                >
                  {/* filter options */}
                  <option> -- </option>
                  {assessments.map((assessment) => (
                    <option key={assessment.id} value={assessment.id}>
                      {assessment.name}
                    </option>
                  ))}
                </select>
              </span>
            </div>

            {/* assessment options */}
            <div
              className={`${
                selectedAssessment ? "show-picker" : "hide-search-picker "
              }`}
            >
              <span>Choose a year group &nbsp; </span>
              <span>
                <select
                  className="custom-select sf-select"
                  onChange={this.onSelectFilter.bind(this, "yrgrp")}
                  style={{ width: "250px" }}
                  defaultValue={currentYearGroup}
                >
                  <option> -- </option>
                  {yearGroups.map((grp) => (
                    <option key={grp} value={grp}>
                      {grp}
                    </option>
                  ))}
                </select>
              </span>
            </div>

            <div
              className={`${
                selectedAssessment ? "show-picker" : "hide-search-picker "
              }`}
            >
              <span>Choose a department &nbsp; </span>
              <span>
                <select
                  className="custom-select sf-select"
                  onChange={this.onSelectFilter.bind(this, "department")}
                  style={{ width: "250px" }}
                  defaultValue={currentDepartment}
                >
                  <option> -- </option>
                  {departments.map((dept) => (
                    <option key={dept} value={dept}>
                      {dept}
                    </option>
                  ))}
                </select>
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }
  public async onSelectAssessment(event) {
    // get assessment id & fetch question groups
    const {
      services: { currentUserID, fixturesAPI, institutionsAPI },
      dispatch,
    } = this.props;

    dispatch(
      updateMultipleVals({
        loaded: false,
        yearGroups: [],
        departments: [],
        questionGroups: [],
      })
    );
    const selectedAssessment = event.target.value;
    dispatch(getAssessmentSearchFilters(currentUserID, selectedAssessment, ""));

    dispatch(getYearGroupsDepartments(currentUserID));
  }

  public async onQuestionGroupClicked(event) {
    // set questiongroupid
    const selectedGroup = event.target.value;
    this.fetchQuestionGroupData(selectedGroup);
  }
  public async fetchQuestionGroupData(selectedGroup) {
    const {
      services: { currentUserID, fixturesAPI, institutionsAPI },
      dispatch,
      schoolSFReducer,
    } = this.props;
    dispatch(
      updateMultipleVals({ selectedGroup, filteredStudents: [], loaded: false })
    ); // use to change button styles
    const { selectedAssessment } = schoolSFReducer;

    dispatch(
      getStudentsFiltered(currentUserID, selectedGroup, selectedAssessment)
    );
  }

  public onPieSliceClicked = (grpId: string) => (event: React.MouseEvent) => {
    this.fetchQuestionGroupData(grpId);
  };
  public searchFilterButtons() {
    const { questionGroups, selectedAssessment, selectedGroup } =
      this.props.schoolSFReducer;
    if (questionGroups) {
      return (
        <div className="sf-buttons-wrapper">
          {/* ideally mapped from fetched data */}
          {questionGroups.map((questiongrp) => (
            <button
              onClick={this.onQuestionGroupClicked}
              className={this.assignClass(selectedGroup, questiongrp.id)}
              key={questiongrp.id}
              value={questiongrp.id}
            >
              {questiongrp.Title}
            </button>
          ))}
        </div>
      );
    } else {
      return <div />;
    }
  }

  public renderNoFilterModal = () => {
    return (
      <Modal visible={this.props.schoolSFReducer.noFilters} effect="fadeInDown">
        <div className="exit-modal-container">
          <h3 style={{ color: "#fff", fontStyle: "italic" }}>NO FILTERS</h3>
          <p className="exit-warning">
            This assessment has no filters at the moment. Try choosing another
            one.
          </p>
          <div className="exit-warning-buttons">
            <button className="blue-button" onClick={this.closeFiltersModal}>
              Okay
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  public render() {
    const { loaded, guidesRead } = this.props.schoolSFReducer;

    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <div className="sf-page">
        <Navbar logoutParent={this.onLogout} />
        {this.renderNoFilterModal()}
        <ToastContainer />

        <Tour
          steps={tourSteps}
          isOpen={!guidesRead}
          onRequestClose={this.closeTour}
          onAfterOpen={this.disableBody}
          onBeforeClose={this.enableBody}
          accentColor="#ff0033"
        />
        <div className="sf-container">
          <div className="sf-content">
            <h1 className="sf-page-heading">SEARCH &amp; FILTER RESULTS</h1>
            <div className="sf-page-row">{this.assessmentPicker()}</div>
            <div className="sf-page-row">{this.searchFilterButtons()}</div>
            <div className="sf-page-row step-1">{this.renderChart()}</div>
            {this.resultsTableDisplay()}
            <Loader color="#acff24" loaded={loaded} />
          </div>
        </div>
        <FabButton
          right="8px"
          bottom="36px"
          bgColor="#1a1a1a"
          onClick={this.toggleGuides}
        >
          <p className="fab-text">Need a hand</p>
          <i
            className="fa fa-question"
            style={{ fontSize: "30px", color: "#ff0033" }}
          />
        </FabButton>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { schoolSFReducer: state.schoolSFReducer };
};
export default connect(mapStateToProps)(withServices(SearchFilters));



// WEBPACK FOOTER //
// ./src/pages/DataCenter/SearchFilters/searchFilters.Component.tsx